export const alterationsIt: Record<string, string> = {
  // Filter labels
  'filters.category': 'Categoria',
  'filters.allCategories': 'Tutte le Categorie',
  'filters.brand': 'Marca',
  'filters.allBrands': 'Tutte le Marche',
  'filters.color': 'Colore',
  'filters.allColors': 'Tutti i Colori',
  'filters.sellingPriceRange': 'Gamma Prezzo Vendita (€)',
  'filters.costPriceRange': 'Gamma Prezzo Costo (€)',
  'filters.min': 'Min',
  'filters.max': 'Max',
  'filters.advancedFilters': 'Filtri Avanzati',
  'filters.sizeRange': 'Gamma Taglie',
  'filters.allSizes': 'Tutte le Taglie',
  'filters.supplier': 'Fornitore',
  'filters.allSuppliers': 'Tutti i Fornitori',
  'filters.stockOptions': 'Opzioni Inventario',
  'filters.trackStock': 'Traccia Inventario',
  'filters.allowNegative': 'Consenti Negativo',
  'filters.imageFilter': 'Filtro Immagini',
  'filters.allProducts': 'Tutti i Prodotti',
  'filters.stockAvailableRange': 'Gamma Stock Disponibile',
  'filters.quantityOnHandRange': 'Gamma Quantità Disponibile',

  // Alterations page toasts
  'alterations.toast.fetchError': 'Impossibile recuperare le attività di modifica',
  'alterations.toast.taskMoved': 'Attività spostata con successo',
  'alterations.toast.moveError': 'Impossibile spostare l\'attività',
  'alterations.modal.successTitle': 'Successo',
  'alterations.modal.errorTitle': 'Errore',
  'alterations.modal.taskUpdatedSuccess': 'Attività aggiornata con successo',
  'alterations.modal.taskUpdateError': 'Impossibile aggiornare l\'attività',
  'alterations.modal.unknownCustomer': 'Cliente sconosciuto',
  'alterations.modal.orderLine': 'Ordine #{orderNo} - {customerName}',
  'alterations.modal.photosTab': 'Foto',
  'alterations.modal.timeTrackingTab': 'Tracciamento tempo',
  'alterations.modal.taskTitle': 'Titolo attività',
  'alterations.modal.stage': 'Fase',
  'alterations.modal.selectStage': 'Seleziona fase',
  'alterations.modal.assignee': 'Assegnatario',
  'alterations.modal.selectAssignee': 'Seleziona assegnatario',
  'alterations.modal.unassigned': 'Non assegnato',
  'alterations.modal.descriptionAndNotes': 'Descrizione e note',
  'alterations.modal.descriptionPlaceholder': 'Aggiungi dettagli attività e note interne...',
  'alterations.modal.taskInformation': 'Informazioni attività',
  'alterations.modal.taskType': 'Tipo attività:',
  'alterations.modal.priority': 'Priorità:',
  'alterations.modal.priorityHigh': 'Alta',
  'alterations.modal.priorityMedium': 'Media',
  'alterations.modal.priorityLow': 'Bassa',
  'alterations.modal.created': 'Creata:',
  'alterations.modal.beforePhotos': 'Foto prima ({count})',
  'alterations.modal.beforePhotoAlt': 'Prima {index}',
  'alterations.modal.noBeforePhotos': 'Nessuna foto prima',
  'alterations.modal.afterPhotos': 'Foto dopo ({count})',
  'alterations.modal.afterPhotoAlt': 'Dopo {index}',
  'alterations.modal.noAfterPhotos': 'Nessuna foto dopo',
  'alterations.modal.totalTimeSpent': 'Tempo totale speso su questa attività',
  'alterations.modal.startTimer': 'Avvia timer',
  'alterations.modal.stopTimer': 'Ferma timer',
  'alterations.modal.timerRunning': 'Timer in esecuzione: {elapsed} trascorso',
  'alterations.modal.manualTimeEntry': 'Inserimento tempo manuale',
  'alterations.modal.minutesPlaceholder': 'Minuti',
  'alterations.modal.minutesTotal': 'minuti totali',
  'alterations.modal.saveChanges': 'Salva modifiche',
};
